var _defs, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcons8CurseurSetup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "96px",
    height: "96px",
    fillRule: "nonzero",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: 21.384,
    y1: 6.317,
    x2: 35.554,
    y2: 39.054,
    gradientUnits: "userSpaceOnUse",
    id: "color-1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c046f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07d6f9"
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "none",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "scale(5.33333,5.33333)",
    d: "M28.887,43.911c-0.533,0.232 -1.152,-0.012 -1.384,-0.545l-4.664,-10.728l-7.078,5.903c-0.699,0.583 -1.761,0.086 -1.761,-0.824v-30.663c0,-0.461 0.276,-0.808 0.634,-0.963c0.369,-0.16 0.826,-0.117 1.162,0.219l21.428,21.427c0.644,0.644 0.244,1.747 -0.663,1.828l-8.1,0.726l4.628,10.647c0.232,0.533 -0.012,1.153 -0.545,1.385l-1.792,0.779l-0.00073,-0.00168z",
    id: "strokeMainSVG",
    fill: "#efe1ff",
    stroke: "#efe1ff",
    strokeWidth: 6,
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(5.33333,5.33333)",
    stroke: "none",
    strokeWidth: 1,
    strokeLinejoin: "miter"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14,7.054v30.663c0,0.91 1.062,1.407 1.761,0.824l7.078,-5.903l4.664,10.728c0.232,0.533 0.851,0.777 1.384,0.545l1.865,-0.811l-16.118,-37.009c-0.358,0.155 -0.634,0.502 -0.634,0.963z",
    fill: "#a570f0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.089,40.938l-4.628,-10.647l8.1,-0.726c0.907,-0.081 1.307,-1.184 0.663,-1.828l-21.428,-21.427c-0.336,-0.336 -0.793,-0.379 -1.162,-0.219l16.118,37.011l1.792,-0.779c0.533,-0.232 0.777,-0.852 0.545,-1.385z",
    fill: "url(#color-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.089,40.938l-4.628,-10.647l8.1,-0.726c0.907,-0.081 1.307,-1.184 0.663,-1.828l-21.428,-21.427c-0.336,-0.336 -0.793,-0.379 -1.162,-0.219l16.118,37.011l1.792,-0.779c0.533,-0.232 0.777,-0.852 0.545,-1.385z",
    fill: "#6f40dd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8CurseurSetup);
export default __webpack_public_path__ + "static/media/icons8-curseur-setup.254f2cf17fa4ddcc4bb16d248ea30d2d.svg";
export { ForwardRef as ReactComponent };